<p-table [value]="csses" >
    <ng-template pTemplate="header">
        <tr>
            <th>ID</th>
            <th>Name</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-css>
        <tr routerLink="/management/edit-pdf-css/{{css.id}}">
            <td>{{css.id}}</td>
            <td>{{css.name}}</td>
        </tr>
    </ng-template>
</p-table>